import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';

import { IS_IFRAME_MODE } from 'config/envVariable';

const PowerBy = () => {
    const promoId = useSelector(s => s.promo.id);
    const sponsorName = useSelector(s => s.sponsor?.name);
    const enablePoweredBy = useSelector(s => s.settingPlan?.enablePoweredBy);
    const scenes = useSelector(s => s.promoState?.scenes);
    const isZinesEmbedded = useSelector(s => s.appState?.isZinesEmbedded);

    return (!IS_IFRAME_MODE || (scenes === 'plugin' && !isZinesEmbedded)) && enablePoweredBy ? (
        <div>
            <a
                href={`https://info.feversocial.com/tw?utm_source=${window.location.hostname}&utm_medium=promo_${promoId}&utm_campaign=poweredby`}
                target="_blank"
                rel="noopener noreferrer"
                css={powerByStyle}
            >
                {sponsorName} powered by <strong>fever</strong>social
            </a>
        </div>
    ) : null;
};

export default PowerBy;

const powerByStyle = css`
    text-decoration: none;
    background: rgba(255, 255, 255, 0.4);
    color: #333333;
    font-size: 0.875rem;
    width: 100%;
    display: block;
    text-align: center;
    line-height: 32px;
`;
